import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = () => {
  const activities = [
    {
      id: 1,
      type: 'match',
      title: "New candidate match",
      description: "Senior React Developer in Oslo matches your search criteria",
      timestamp: new Date(Date.now() - 300000),
      icon: 'UserCheck',
      color: 'success'
    },
    {
      id: 2,
      type: 'unlock',
      title: "Profile unlocked",
      description: "You unlocked Maria S. - Full Stack Developer",
      timestamp: new Date(Date.now() - 1800000),
      icon: 'Unlock',
      color: 'primary'
    },
    {
      id: 3,
      type: 'search',
      title: "Search alert triggered",
      description: "3 new candidates for \'Frontend Developer\' search",
      timestamp: new Date(Date.now() - 3600000),
      icon: 'Search',
      color: 'accent'
    },
    {
      id: 4,
      type: 'team',
      title: "Team member activity",
      description: "John added 2 candidates to \'Senior Positions\' shortlist",
      timestamp: new Date(Date.now() - 7200000),
      icon: 'Users',
      color: 'secondary'
    },
    {
      id: 5,
      type: 'response',
      title: "Candidate responded",
      description: "Erik L. replied to your message about the DevOps position",
      timestamp: new Date(Date.now() - 10800000),
      icon: 'MessageCircle',
      color: 'success'
    }
  ];

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    
    if (minutes < 60) {
      return `${minutes}m ago`;
    } else if (hours < 24) {
      return `${hours}h ago`;
    } else {
      return `${Math.floor(hours / 24)}d ago`;
    }
  };

  return (
    <div className="bg-card rounded-xl p-6 shadow-elevation border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
        <button className="text-sm text-primary hover:text-primary/80 transition-micro">
          View all
        </button>
      </div>
      <div className="space-y-4">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-muted/30 transition-micro">
            <div className={`h-8 w-8 rounded-full bg-${activity?.color}/10 flex items-center justify-center flex-shrink-0`}>
              <Icon name={activity?.icon} size={16} className={`text-${activity?.color}`} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground">{activity?.title}</p>
              <p className="text-sm text-muted-foreground mt-1">{activity?.description}</p>
              <p className="text-xs text-muted-foreground mt-2">{formatTimeAgo(activity?.timestamp)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;